const storageAccountName = "ittybrief";

export const storageUrl = `https://${storageAccountName}.blob.core.windows.net`;

export const getBlobUrl = (container: string, documentId: string) =>
  `https://${storageAccountName}.blob.core.windows.net/${container}/${documentId}`;
